import { render, staticRenderFns } from "./UpdateInfoPopup.vue?vue&type=template&id=f58cface&scoped=true"
import script from "./UpdateInfoPopup.vue?vue&type=script&lang=js"
export * from "./UpdateInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./UpdateInfoPopup.vue?vue&type=style&index=0&id=f58cface&prod&scoped=true&lang=scss"
import style1 from "./UpdateInfoPopup.vue?vue&type=style&index=1&id=f58cface&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58cface",
  null
  
)

export default component.exports